import { render, staticRenderFns } from "./MatrixVariationItem.vue?vue&type=template&id=4e81539b&"
import script from "./MatrixVariationItem.vue?vue&type=script&lang=js&"
export * from "./MatrixVariationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\matrix_varianten\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e81539b')) {
      api.createRecord('4e81539b', component.options)
    } else {
      api.reload('4e81539b', component.options)
    }
    module.hot.accept("./MatrixVariationItem.vue?vue&type=template&id=4e81539b&", function () {
      api.rerender('4e81539b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/MatrixVariationItem.vue"
export default component.exports